


























































































import Vue from "vue";

import * as ad from "@/store/modules/DevicesModule/actions";
import * as m from "@/store/modules/DevicesModule/mutations";

//Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DeleteFolderCommand } from "@/model/communication/foldersManagement/DeleteFolderCommand";
import { GetOrganizationsCommand } from "@/model/communication/organizations/GetOrganizationsCommand";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import _ from "lodash";
import { mapActions, mapMutations, mapState } from "vuex";

export default Vue.extend({
    data() {
        return {
            DeviceTreeNodeTypeEnum,
            deleteFolderLoading: false,
            emptyFolder: [],
            fullFolder: [],
            toFullFoldersLimit: 100,
            organizations: [],
        };
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),
        emptyFolderTextColor() {
            if (this.emptyFolder.length == 0) return "success--text";
            else if (this.emptyFolder.length < 2) return "warning--text";
            else return "error--text";
        },
        fullFolderTextColor() {
            if (this.fullFolder.length == 0) return "success--text";
            else if (this.fullFolder.length < 2) return "warning--text";
            else return "error--text";
        },
        emptyFolderIcon() {
            if (this.emptyFolder.length == 0) return "thumbs-up";
            else if (this.emptyFolder.length < 2) return "exclamation-circle";
            else return "exclamation-triangle";
        },
        fullFolderIcon() {
            if (this.fullFolder.length == 0) return "thumbs-up";
            else if (this.fullFolder.length < 2) return "exclamation-circle";
            else return "exclamation-triangle";
        },
    },
    methods: {
        ...mapActions([ad.FETCH_ALL_DEVICE_TREE]),
        ...mapMutations([m.SET_DEVICE_TREE_CONTENT]),

        deleteFolder(folderId) {
            this.sendRequestDeleteFolder(folderId);
        },
        async sendRequestDeleteFolder(folderId) {
            this.deleteFolderLoading = true;
            try {
                let res = await new DeleteFolderCommand(folderId).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    await new Promise((r) => setTimeout(r, 2000));
                    this[m.SET_DEVICE_TREE_CONTENT]({ node: null, content: [] });
                    await this[ad.FETCH_ALL_DEVICE_TREE]();
                    this.calculateWrongFolder();
                }
            } catch (error) {
                console.error("error in deleteFolder, exc: ", error);
            }
            this.deleteFolderLoading = false;
        },
        calculateWrongFolder() {
            if (this.deviceTree) {
                let stack = [];
                let resultEmpty = [];
                let resultFull = [];
                stack.push([this.deviceTree[0], []]);
                while (stack.length > 0) {
                    let obj = stack.pop();
                    let node = obj[0];
                    let path = obj[1];
                    if (node && node.type == DeviceTreeNodeTypeEnum.Folder) {
                        if (node.children.length == 0 && node != this.deviceTree[0]) {
                            let editedNode = JSON.parse(JSON.stringify(node));
                            editedNode.name = `${path.join("/")}/${node.name}`.replace("//", "/");
                            resultEmpty.push(editedNode);
                        }
                        if (node.id != 1 && node.children.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > this.toFullFoldersLimit) {
                            let editedNode = JSON.parse(JSON.stringify(node));
                            editedNode.name = `${path.join("/")}/${node.name}`.replace("//", "/");
                            resultFull.push(editedNode);
                        }
                    }
                    if (node && node.children) {
                        for (let child of node.children) {
                            stack.push([child, path.concat([node.name])]);
                        }
                    }
                }
                this.emptyFolder = resultEmpty;
                this.fullFolder = resultFull;
            }
        },

        async getOrganizations() {
            try {
                const res = await new GetOrganizationsCommand().execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.organizations = _.cloneDeep(res.organizations);
                }
            } catch (e) {
                console.log("Something went wrong during GetOrganizationsCommand execution: ", e);
            }
        },
    },
    async mounted() {
        this.calculateWrongFolder();
        await this.getOrganizations();
    },
});
